import { api } from "./api";

// First-party, anonymous session id (no PII). Stored locally for funnel linkage.
export function getSessionId() {
  return sessionId();
}

function sessionId() {
  try {
    let id = localStorage.getItem("mm_sid");
    if (!id) {
      id = (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2));
      localStorage.setItem("mm_sid", id);
    }
    return id;
  } catch {
    return "anon";
  }
}

// Fire-and-forget. Never blocks the UI or throws.
export function track(event, { source = "", meta = {} } = {}) {
  try {
    api.post("/track", { session_id: sessionId(), event, source, meta }).catch(() => {});
  } catch { /* ignore */ }
}
